const escapeDelimitedValue = (value: string, delimiter: string): string => {
  const escapedValue = value.replace(/"/g, '""');
  const containsDelimiter =
    delimiter.length > 0 && escapedValue.includes(delimiter);

  return containsDelimiter || /["\r\n]/.test(escapedValue)
    ? `"${escapedValue}"`
    : escapedValue;
};

export default escapeDelimitedValue;
